import { useEffect, useState } from "react";

import { AddressManager } from "@/components/dashboard/address-manager";
import { DashboardShell } from "@/components/dashboard/dashboard-shell";
import { apiGet } from "@/services/api";
import type { Address } from "@/types/prisma";

/** `app/dashboard/addresses/page.tsx`. */
export function AddressesPage() {
  const [addresses, setAddresses] = useState<Address[] | null>(null);

  useEffect(() => {
    let active = true;
    void apiGet<{ addresses: Address[] }>("/api/addresses").then((data) => {
      if (active) setAddresses(data?.addresses ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  if (addresses === null) {
    return (
      <DashboardShell title="Addresses">
        <div className="h-40 animate-pulse rounded-lg bg-slate-100 dark:bg-white/5" />
      </DashboardShell>
    );
  }

  return (
    <DashboardShell title="Addresses">
      <AddressManager initialAddresses={addresses} />
    </DashboardShell>
  );
}
